import IMediaKit from 'interfaces/IMediaKit';
import RestService from './RestService';

export default class MediaKitService extends RestService<IMediaKit> {
  constructor() {
    super('media-kits');
  }
}
